"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies_1 = require("./Cookies");
var RegisterExperiment_1 = __importDefault(require("../Experiment/RegisterExperiment"));
var RegisterMultipleExperiments_1 = __importDefault(require("../Experiment/RegisterMultipleExperiments"));
var utilities_1 = require("../utilities");
var FetchExperimentData = function (experiments, settings, serverCookies, serverHeaders) {
    if (settings === void 0) { settings = {}; }
    if (serverCookies === void 0) { serverCookies = {}; }
    if (serverHeaders === void 0) { serverHeaders = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var experimentKeys, response, updateResponse, identifier, identifierToUse, experimentsToRegister;
        return __generator(this, function (_a) {
            experimentKeys = Object.keys(experiments);
            response = {
                experiments: {},
                cookies: []
            };
            updateResponse = function (name, updatedExperiments, shouldSetCookie) {
                if (shouldSetCookie === void 0) { shouldSetCookie = true; }
                var _a = updatedExperiments[name], assignedBucket = _a.assignedBucket, hasErrored = _a.hasErrored;
                var _b = settings.cacheMinutes, cacheMinutes = _b === void 0 ? 15 : _b;
                var cookieExpire = Cookies_1.calculateExpiredDate(cacheMinutes);
                if (hasErrored || !assignedBucket)
                    return;
                if (shouldSetCookie && assignedBucket && cacheMinutes > 0) {
                    response.cookies.push(name + "=" + assignedBucket + cookieExpire + "; path=/");
                }
                response.experiments[name] = updatedExperiments[name];
            };
            identifier = settings.identifier;
            identifierToUse = identifier || utilities_1.getIdentifierFromAuthToken();
            if (!identifierToUse) {
                return [2 /*return*/, Promise.all(experimentKeys.map(function (name) {
                        var _a = experiments[name].defaultBucket, defaultBucket = _a === void 0 ? 'control' : _a;
                        return RegisterExperiment_1.default(__assign(__assign({}, settings), { name: name, experiments: response.experiments, defaultBucket: defaultBucket,
                            serverCookies: serverCookies }), updateResponse);
                    })).then(function () { return response; })];
            }
            experimentsToRegister = Object.keys(experiments).map(function (name) {
                var _a = experiments[name].defaultBucket, defaultBucket = _a === void 0 ? 'control' : _a;
                return {
                    experimentName: name,
                    defaultBucket: defaultBucket
                };
            });
            return [2 /*return*/, RegisterMultipleExperiments_1.default(__assign(__assign({}, settings), { identifier: identifierToUse, experimentsToRegister: experimentsToRegister, experiments: response.experiments, serverCookies: serverCookies,
                    serverHeaders: serverHeaders }), updateResponse).then(function () { return response; })];
        });
    });
};
exports.default = FetchExperimentData;
